import Bugsnag from '@bugsnag/js';

export class CustomAxiosError extends Error {
  constructor (axiosError) {
    super(axiosError.message);
    this.code = axiosError.code;
    this.config = axiosError.config;
    this.request = axiosError.request;
    this.response = axiosError.response;
    this.name = 'CustomAxiosError';
  }
}

export class ValidationError extends Error {
  constructor (error) {
    super(error.message);
    this.code = error.code;
    this.config = error.config;
    this.request = error.request;
    this.response = error.response;

    const errorsDescription = error.response?.data?.errors?.length ? error.response.data.errors.reduce((acc, err) => {
      acc += `${err.detail} \n`;
      return acc;
    }, '')
      : 'no validation error details';

    this.name = `Validation Errors: ${errorsDescription}`;
  }
}

export const handleValidationError = (error) => {
  const bugsnagMetadata = getFailedResponseMetadata(error);
  Bugsnag.leaveBreadcrumb('Submit Failed', bugsnagMetadata, 'request');

  Bugsnag.notify(new ValidationError(error), (event) => {
    event.addMetadata('Payload Validation Error', bugsnagMetadata);
  });
};

export const getFailedResponseMetadata = (error) => ({
  error: {
    code: error.code,
    message: error.message,
    name: error.name,
  },
  request: {
    url: error.request.responseURL,
    method: error.config.method?.toUpperCase(),
    headers: error.config.headers,
    ...error.config.data ? { data: JSON.parse(error.config.data) } : {},
  },
  response: {
    headers: error.response.headers,
    status: error.response.status,
    statusText: error.response.statusText,
    data: error.response.data,
  },
});

export const getSuccessResponseMetadata = (response) => ({
  request: {
    url: response.request.responseURL,
    method: response.config.method.toUpperCase(),
    headers: response.config.headers,
    ...response.config.data ? { data: JSON.parse(response.config.data) } : {},
  },
  response: {
    headers: response.headers,
    status: response.status,
    statusText: response.statusText,
    data: response.data,
  },
});
